// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"b64a75b4","304":"14cb2905"}[chunkId] + ".chunk.js";
};